import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataFixedAsset } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_FIXED_ASSET = defineMasterdataEntity<MasterdataFixedAsset>({
  name: 'fixed-asset',
  responseKey: 'fixedAssets',
  displayWith: (a) => {
    const number = a.subNumber > 0 ? `${a.key}/${a.subNumber}` : a.key;
    return keyName(number, a.name);
  },
  secondaryWith: (a) => a.inventoryNumber ?? a.assetGroup?.name ?? null,
  icon: 'fa-regular fa-building',
  title: 'Anlagensuche',
  label: 'Anlage',
  placeholder: 'Anlage suchen...',
  columns: [
    {
      label: 'Anlage',
      type: 'entity',
      icon: 'fa-regular fa-building',
      value: (e) =>
        keyName(e.subNumber > 0 ? `${e.key}/${e.subNumber}` : e.key, e.name),
      secondary: (e) => e.inventoryNumber ?? e.assetGroup?.name ?? null,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Subnummer', type: 'text', value: (e) => e.subNumber },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    {
      label: 'Inventarnummer',
      type: 'text',
      value: (e) => e.inventoryNumber,
    },
    {
      label: 'Inbetriebnahme',
      type: 'text',
      value: (e) => e.placedInServiceDate,
    },
    { label: 'Anlagen-ID', type: 'text', value: (e) => e.assetId },
    {
      label: 'Anlagengruppe',
      type: 'text',
      value: (e) => e.assetGroup?.name ?? null,
    },
  ],
});
